import { createApp } from 'vue'
import App from './App.vue'
import 'leaflet/dist/leaflet.css'

// Optimize Leaflet configuration
import L from 'leaflet'
L.Browser.mobile = true // Force mobile optimizations
L.Browser.touch = true // Enable touch optimizations
L.Browser.retina = window.devicePixelRatio > 1 // Detect retina displays

// Make Leaflet available globally
window.L = L

createApp(App).mount('#app')
